export enum InvoiceLinesRequestOperation {
  AMEND = 'AMEND',
}

export const InvoiceLinesRequestOperationDescription =
  'The operation to apply (e.g. amend) on lines of the InvoiceLinesRequest for an invoice.';
